<template>
  <div class="version">
    <div
      class="ver_part"
      @click="go_detail($event, item, item.id)"
      v-for="item in list"
      :key="item.id"
    >
      <figure>
        <img :src="item.appIconUrl" />
        <figcaption>
          {{ item.appName }}
          <img class="copy" id="copy_id" src="@/assets/Jimage/copyUrl.png" />
        </figcaption>
        <figcaption>{{ item.appVersion }}</figcaption>
      </figure>
      <div class="times">
        <div>
          预览次数：<span>{{ item.viewCount }}</span>
        </div>
        <div>
          下载次数：<span>{{ item.downloadCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { app_list, countTimes } from "@/api/tool_app";
export default {
  data() {
    return {
      list: [],
    };
  },
  computed: mapState(["texts_status"]),
  mounted() {
    //获取应用列表 app_list
    this.get_list();
  },
  methods: {
    //复制apk链接
    copy_url(text) {
      if (typeof document.execCommand !== "function") {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        return;
      }
      var dom = document.createElement("textarea");
      dom.value = text;
      dom.setAttribute("style", "display: block;width: 1px;height: 1px;");
      document.body.appendChild(dom);
      dom.select();
      var result = document.execCommand("copy");
      document.body.removeChild(dom);
      if (result) {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        return;
      }
      if (typeof document.createRange !== "function") {
        this.$message({
          message: "复制失败",
          type: "error",
        });
        return;
      }
      var range = document.createRange();
      var div = document.createElement("div");
      div.innerHTML = text;
      div.setAttribute("style", "height: 1px;fontSize: 1px;overflow: hidden;");
      document.body.appendChild(div);
      range.selectNode(div);
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      selection.addRange(range);
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    async get_list() {
      let res = await app_list();
      this.list = [...res.data];
    },
    //查看版本详情
    go_detail(e, item, id) {
      if (e.target.id == "copy_id") {
        this.copy_url(item.apkUrl);
      } else {
        let res = countTimes({
          id: id,
          type: 1,
        });
        this.$store.state.texts_status = 3;
        this.$router.push({ name: "ver_detail", params: item });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.version {
  padding: 0px 80px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  align-content: flex-start;
  .ver_part {
    border-radius: 3px;
    margin-top: 10px;
    margin-right: 10px;
    width: 243px;
    height: 206px;
    background-color: #fff;
    figure {
      height: 139px;
      padding-top: 28px;
      margin-top: 0px;
      margin-bottom: 0;
      text-align: center;
      figcaption {
        margin: 5px 0px 0px 0px;
        position: relative;
        .copy {
          position: absolute;
          width: 18px;
          height: 18px;
          margin-left: 7px;
        }
      }
      img {
        width: 60px;
        height: 48px;
      }
      &:nth-child(1) {
        @include s-c-w(14, $menu-text, 500);
      }
      & > figcaption:last-child {
        @include s-c-w(12, $text-other, 500);
      }
    }
    .times {
      height: 66px;
      line-height: 66px;
      border-top: 1px dotted $e6;
      display: flex;
      justify-content: space-around;
      @include s-c-w(12, $detail_t, 500);
      span {
        color: $tab;
      }
    }
  }
}
</style>